// Import model
import { CreateProjectTaskRequest } from '../models/CreateProjectTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateProjectTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateProjectTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateProjectTaskRequest instance
   */
  static deserialize(json: string): CreateProjectTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateProjectTaskRequest instance
   */
  static fromObject(obj: any): CreateProjectTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateProjectTaskRequest');
    }


    const instance: CreateProjectTaskRequest = {
      parentObjectId: obj['parentObjectId'] as string,
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      content: obj['content'] as string | undefined,
      description: obj['description'] as string | undefined,
      name: obj['name'] as string,
      assignedUserId: obj['assignedUserId'] as string | undefined,
      dueDate: obj['dueDate'] as string | undefined,
      priority: obj['priority'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      creatorId: obj['creatorId'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateProjectTaskRequest instances
   */
  static deserializeArray(json: string): CreateProjectTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateProjectTaskRequest instance to a JSON string
   */
  static serialize(instance: CreateProjectTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateProjectTaskRequest instance to a plain object
   */
  static toObject(instance: CreateProjectTaskRequest): any {
    return {
      'parentObjectId': instance.parentObjectId,
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
      'content': instance.content,
      'description': instance.description,
      'name': instance.name,
      'assignedUserId': instance.assignedUserId,
      'dueDate': instance.dueDate,
      'priority': instance.priority,
      'contentType': instance.contentType,
      'creatorId': instance.creatorId,
      'entityId': instance.entityId,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of CreateProjectTaskRequest instances to a JSON string
   */
  static serializeArray(instances: CreateProjectTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
